import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HelpText = styled(Typography)(({ theme }) => ({
  marginTop: '8px',
  fontSize: '14px',
  color: theme.palette.common.grey,
  maxWidth: '720px',
}));

export const FormRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  marginTop: '24px',
  flexWrap: 'wrap',

  '& .MuiTextField-root': {
    flex: 1,
    minWidth: '320px',
  },

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'stretch',
  },
}));

export const Actions = styled(Box)(() => ({
  display: 'flex',
  gap: '12px',
  flexShrink: 0,
}));

export const FilledButton = styled(Button)(({ theme }) => ({
  width: '160px',
  height: '48px',
  color: theme.palette.common.white,
  textTransform: 'lowercase',
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));

export const OutlinedButton = styled(Button)(({ theme }) => ({
  width: '160px',
  height: '48px',
  border: `1.5px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: theme.palette.common.white,
  textTransform: 'lowercase',
  '&:disabled': {
    color: theme.palette.secondary.main,
    opacity: 0.6,
  },
}));

export const PreviewGrid = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  marginTop: '24px',
}));

export const PlayerWrapper = styled(Box)(() => ({
  width: '100%',
  maxWidth: '720px',
  aspectRatio: '16 / 9',
  borderRadius: '12px',
  overflow: 'hidden',
  backgroundColor: '#000',
  boxShadow: '0 2px 12px rgba(16, 24, 40, 0.12)',
}));

export const PlayerFrame = styled('iframe')(() => ({
  display: 'block',
  width: '100%',
  height: '100%',
  border: 0,
}));

export const UnsupportedLink = styled(Typography)(({ theme }) => ({
  padding: '12px 16px',
  borderRadius: '8px',
  border: `1px solid ${theme.palette.warning.main}`,
  fontSize: '14px',
  color: theme.palette.common.grey,
  maxWidth: '720px',
}));

export const RemoveRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px',
  maxWidth: '720px',
  flexWrap: 'wrap',
}));

export const SavedLink = styled('a')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  fontSize: '14px',
  fontWeight: 600,
  color: theme.palette.primary.main,
  textDecoration: 'none',
  overflowWrap: 'anywhere',
  '&:hover': { textDecoration: 'underline' },
  '& span': { fontSize: '18px' },
}));

export const EmptyState = styled(Typography)(({ theme }) => ({
  marginTop: '16px',
  color: theme.palette.common.grey,
}));
